import group_quality from "./quality_group";

export default {
  methods: {
    calculateGeneralOperationByGroup: function (quality_group, general_values) {
      // general_values format:
      // general_values = {
      //   quality_group_id: {
      //     quality_attribute_id: value
      //   }
      // }
      if (!quality_group.use_operation) return 0;
      let data = general_values[quality_group.id];
      delete data[quality_group.quality_attribute_id];
      data = Object.values(data)
        .map((value) => Number(value) ?? 0)
        .filter((d) => d);
      const calculated_value =
        group_quality.methods.operateData(data, quality_group);
      return calculated_value;
    },
    getPercentageGeneralValue: function (group, attribute) {
      const total = this.calculateGeneralOperationByGroup(
        group,
        this.general_values
      );
      const attribute_value = this.getGeneralValue(group, attribute);
      if (attribute_value && total > 0)
        return Number(this.getFormatNumber(100 * (attribute_value / total), 2));
      else return 0;
    },
    getGeneralValue: function (group, attribute) {
      if (!this.quality_template) return 0;
      let total = 0;
      if (group.quality_attribute_id == attribute.id)
        total = this.calculateGeneralOperationByGroup(
          group,
          this.general_values
        );
      else total = this.general_values[group.id][attribute.id];
      return total;
    },
  }
}